import { bootstrapApp } from "@/bootstrapApp";
import {
  applyThemePreference,
  readInitialThemePreference,
} from "@/contexts/themePreference";
import "@/i18n";
import "@/styles/global.css";

// React applies the theme from an effect, which runs after the first paint:
// on a dark-theme reload that paint is the light theme, and the page opens
// with a white flash. Naming the theme here puts it on the document before
// anything is painted.
applyThemePreference(readInitialThemePreference());

bootstrapApp();
